// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ie","contentWrapCtaDefault":"je","disabled":"ke","contentWrapCtaWhite":"le","promos":"me","lazyPromo":"ne","mainContent":"oe","headingText":"pe","copy":"qe","subtext":"re"};